<div (click)="log(items)"  class="z-50 fix-sroll-bar-menu" (click)="sidenavClick()">
  <stdout-sidenav [items]="items" [user]="User" color="white" title="CS Mida"
    minTitle="CS M"></stdout-sidenav>
</div>
<!-- Il menu cambia in base se metti rightSubmenu o bottomSubmenu-->
